import React from "react";
import { LiveCounter, CountdownTimer } from "../common";
import { getEventStatusText } from "../../../utils/newyear/eventDateUtils";

const LaunchpadStatus = ({ status }) => {
  if (!status) return null;

  const {
    eventStatus,
    remainingSlots,
    totalSlots,
    openTime,
    closeTime,
    currentQuestion,
  } = status;

  const isOpen = eventStatus === "OPEN";
  const isScheduled = eventStatus === "SCHEDULED";

  return (
    <div className="newyear-launchpad-status">
      <div className="newyear-launchpad-status__header">
        <h3 className="newyear-launchpad-status__title">선착순 퀴즈 이벤트</h3>
        <span className={`newyear-launchpad-status__badge newyear-launchpad-status__badge--${eventStatus.toLowerCase()}`}>
          {getEventStatusText(eventStatus)}
        </span>
      </div>

      <div className="newyear-launchpad-status__info">
        <LiveCounter
          current={remainingSlots}
          total={totalSlots}
          label="남은 당첨 자리"
        />

        {isScheduled && openTime && (
          <CountdownTimer
            deadline={openTime}
            label="시작까지"
          />
        )}

        {isOpen && closeTime && (
          <CountdownTimer
            deadline={closeTime}
            label="종료까지"
          />
        )}
      </div>

      {currentQuestion && (
        <div className="newyear-launchpad-status__question-info">
          <span>현재 문제: {currentQuestion.order}번</span>
          <span className={`newyear-launchpad-status__difficulty newyear-launchpad-status__difficulty--${currentQuestion.difficulty.toLowerCase()}`}>
            {currentQuestion.difficulty}
          </span>
        </div>
      )}
    </div>
  );
};

export default LaunchpadStatus;
